import { gql } from "@apollo/client";

export const createFiledTokens = gql`
mutation getPrePaymentDetails($amount : String!) {
    getPrePaymentDetails(amount: $amount) {
    	tax
    	token
  }
}
`;